/* tslint:disable */
import * as moment from 'moment';
import 'moment-timezone';
import { DataContextService } from '../../services/datacontext.service';
import { Building, Item, TimeZone } from "../../models/masterdata.model";
import { Moment } from "moment";

export class DateHelper {
  static currentfacility: Building[];
  static currentFacilityOffset: number;
  static IANAname: string;
  private static getFacilityCurrentDateTime(currentIANA) {
    const md = moment().tz(currentIANA);
    const year = moment(md, 'YYYY').year();
    const month = moment(md, 'MM').month();
    const date = moment(md, 'dd').date();
    const hours = moment(md, 'HH').hours();
    const minutues = moment(md, 'mm').minutes();

    const result = new Date(year, month, date, hours, minutues, 0);
    return result;
  }

  static minutesToTimeString(val: number): string {
    const hours = Math.floor(val / 60);
    const minutes = val % 60;

    return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:00`;
  }

    static getCurrentFacilityOffsetDetails(facilityId: number): FacilityDetails {
    this.currentfacility = DataContextService.Buildings.filter((f) => f.id == facilityId);
    let facilityDetail: FacilityDetails;
    if (this.currentfacility.length > 0) {
      this.currentFacilityOffset = this.currentfacility[0].timeZoneOffSet;
      this.IANAname = this.currentfacility[0].timeZoneIanaName;
      facilityDetail = {
        IANAName: this.IANAname,
        currentFacilityOffset:  this.currentFacilityOffset,
        currentFacilityDateTimeOffset:  this.getFacilityCurrentDateTime(this.IANAname)
      }
    }

    return facilityDetail;
  }

  static GetTimeForDates(date: Date): string {
    const time = moment(date).format('hh:mm a');
    return time;
  }

  static GetTimeForDateswithFormat(date: Date, format: string): string {
    const time = moment(date).format(format);
    return time;
  }

  static GetDateForDate(date: Date): string {
    const edate = moment(date).format('YYYY/MM/DD');
    return edate;
  }

  static SetDateAndTime(date: string, time: string): Date {
    const combinedDate = moment(date + ' ' + time, 'YYYY/MM/DD hh:mm a').toDate();
    return combinedDate;
  }

  static SetDate(date: string): Date {
    const combinedDate = moment(date, 'YYYY/MM/DD hh:mm a').toDate();
    return combinedDate;
  }

  static GetDateWithCurrentFacilityOffset(date: string | Date, facilityId: number = 0, abbreviation?: string): string {
    let offsetDate = '';
    if (facilityId > 0) {
      const currentFacility = this.getCurrentFacilityOffsetDetails(facilityId);
      offsetDate = moment.tz(moment(date).format('YYYY-MM-DDTHH:mm:ss'), currentFacility.IANAName).format();
    }
    else {
      const IANAName = DataContextService.TimeZones.filter((value) => value.abbreviation == abbreviation)[0].id;
      offsetDate = moment.tz(moment(date).format('YYYY-MM-DDTHH:mm:ss'), IANAName).format();
    }
    return offsetDate;
  }

  static RemoveOffsetFromDate(date: string | Date): string {
    return moment.parseZone(date).format('l LT');
    }
  static ConvertUTCToTimeZoneDate(date: string | Date, facilityId: number): string {
      const currentFacility = this.getCurrentFacilityOffsetDetails(facilityId);
      const offsetDate = moment.tz(date, currentFacility.IANAName).format('YYYY-MM-DD HH:mm');
      return offsetDate;
  }
  static ConvertUTCDateToTimeZoneDate(date: string | Date, timezone: string): string {
    const timeZoneId = DataContextService.TimeZones.filter((value) => value.abbreviation == timezone)[0].id;
    const offsetDate = moment.tz(date, timeZoneId).format('YYYY-MM-DD HH:mm');
    return offsetDate;
}
  static GetFormattedTimezone(timezoneValue: any, timezone?: Item) {
    //timezone.id = timezoneValue.id;
    let name ;
    if (timezoneValue.offset.includes('-', 0)) {
      name = '(UTC ' + timezoneValue.offset.slice(0, -3) + ') ' + timezoneValue.displayName;
    } else {
      name = '(UTC +' + timezoneValue.offset.slice(0, -3) + ') ' + timezoneValue.displayName;
    }
    return timezone = {
      id : timezoneValue.id,
      name: name
    }
    }

    static MapDateToApiFormat(date: Date | Moment, tz?: TimeZone, timeZoneAbbreviation?: string) {
    const mDate = moment(date);
    if (!tz) {
      tz = DataContextService.TimeZones.find(tz => tz.abbreviation === timeZoneAbbreviation);
    }
    if(tz.offset.includes('-', 0)) {
    return `${mDate.format('YYYY-MM-DD')}T${mDate.format('HH:mm:ss')}${tz.offset.slice(0, -3)}`}
    else {
    return `${mDate.format('YYYY-MM-DD')}T${mDate.format('HH:mm:ss')}${'+'+tz.offset.slice(0, -3)}`}
    }

    static OnGoingBooking(startDate: string, endDate: string) {
      return moment.utc().isBetween(moment.utc(startDate), moment.utc(endDate));
    };
}

export interface FacilityDetails {
  IANAName: string;
  currentFacilityOffset: number;
  currentFacilityDateTimeOffset: Date;
}
